// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__2OqaD","title":"Label_title__3-Agm","error":"Label_error__2oX4r","required":"Label_required__2Z1Wk"};